import React from "react";
import { Row, Col } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Expander, ItemList } from './styles';

export default ({ line, maxLines, lineExpand, data, callback }) => {
    const list = formatList(data);

    function formatList(list) {
        let formatedList = []
        if (list.length > 0) {
            formatedList = list.slice(0, maxLines)
        }
        return formatedList;
    }

    if (line == lineExpand) {
        return (
            <Row align={"middle"} wrap={false}>
                <Col flex="auto">{list.map((item, index) => (<ItemList key={index}>{item.codparc + ' - ' + item.trading_name}</ItemList>))}</Col>
                <Col flex="20px">{<Expander onClick={() => callback()}><CaretUpOutlined /></Expander>}</Col>
            </Row>
        )
    } else {
        return (
            <Row align={"middle"} wrap={false}>
                <Col flex="auto"><ItemList>{data.length > 0 ? data[0].codparc + ' - ' + data[0].trading_name : null}</ItemList></Col>
                <Col>{data.length > 1 ? <Expander onClick={() => callback()}>{`+${data.length - 1}`}</Expander> : null}</Col>
            </Row>
        )
    }
}